import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { SiFacebook, SiLine } from "react-icons/si";

const NEW_LOGO = "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/ENZO%202026%20Logo%20RGB%20Trans-01_50a56c58d8b844dbbd7924c8c679b113.png";

interface SiteNavbarProps {
  currentPage?: string;
}

const links = [
  { label: "หน้าแรก", href: "/#/" },
  { label: "สินค้า", href: "/#/products" },
  { label: "รีวิว", href: "/#/reviews" },
  { label: "เกี่ยวกับเรา", href: "/#/about" },
  { label: "ติดต่อเรา", href: "/#/#contact" },
];

const SiteNavbar: React.FC<SiteNavbarProps> = ({ currentPage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(typeof window !== "undefined" && window.scrollY > 40);
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handler);
      return () => window.removeEventListener("scroll", handler);
    }
  }, []);

  return (
    <>
      <nav
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 50,
          transition: "background 0.3s, border-color 0.3s",
          background: scrolled ? "rgba(13,13,13,0.97)" : "rgba(13,13,13,0.75)",
          borderBottom: scrolled ? "1px solid rgba(232,33,42,0.3)" : "1px solid transparent",
          boxShadow: scrolled ? "0 2px 20px rgba(0,0,0,0.5)" : "none",
        }}
      >
        <div className="container mx-auto px-4">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: "64px" }}>
            {/* Logo */}
            <a href="/#/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
              <img src={NEW_LOGO} alt="ENZO Performante Store" style={{ height: "40px", objectFit: "contain" }} />
            </a>

            {/* Desktop Links */}
            <div className="hidden md:flex items-center gap-5">
              {links.map((l) => {
                const active = currentPage === l.href;
                return (
                  <a
                    key={l.href}
                    href={l.href}
                    style={{
                      color: active ? "#E8212A" : "#e5e5e5",
                      fontSize: "13px",
                      fontWeight: 700,
                      fontFamily: "Rajdhani, sans-serif",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      textDecoration: "none",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => {
                      (e.currentTarget as HTMLAnchorElement).style.color = "#E8212A";
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => {
                      (e.currentTarget as HTMLAnchorElement).style.color = active ? "#E8212A" : "#e5e5e5";
                    }}
                  >
                    {l.label}
                  </a>
                );
              })}
            </div>

            {/* CTA + Mobile toggle */}
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <a
                href="https://www.facebook.com/EnzoPerformanteStore/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "8px 14px",
                  background: "#1877F2",
                  color: "#fff",
                  borderRadius: "2px",
                  fontSize: "13px",
                  fontWeight: 700,
                  textDecoration: "none",
                  fontFamily: "Rajdhani, sans-serif",
                }}
              >
                <SiFacebook size={13} />
                <span className="hidden sm:inline">Facebook</span>
              </a>
              <button
                className="md:hidden"
                onClick={() => setIsOpen(!isOpen)}
                style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", padding: "4px" }}
              >
                {isOpen ? <X size={22} /> : <Menu size={22} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div style={{ background: "rgba(13,13,13,0.98)", borderTop: "1px solid rgba(232,33,42,0.2)", padding: "12px 16px" }}>
            {links.map((l) => (
              <div key={l.href} style={{ padding: "10px 0", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                <a
                  href={l.href}
                  onClick={() => setIsOpen(false)}
                  style={{
                    color: currentPage === l.href ? "#E8212A" : "#e5e5e5",
                    fontFamily: "Rajdhani, sans-serif",
                    fontSize: "16px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    textDecoration: "none",
                  }}
                >
                  {l.label}
                </a>
              </div>
            ))}
          </div>
        )}
      </nav>

      {/* Floating LINE button */}
      <a
        href="https://lin.ee/usuFQKq"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          right: "20px",
          bottom: "80px",
          zIndex: 100,
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "12px 16px",
          background: "#06C755",
          color: "#fff",
          borderRadius: "50px",
          textDecoration: "none",
          fontFamily: "Rajdhani, sans-serif",
          fontWeight: 700,
          fontSize: "14px",
          boxShadow: "0 4px 20px rgba(6,199,85,0.4)",
          transition: "transform 0.2s",
        }}
        onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => {
          (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1.05)";
        }}
        onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => {
          (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1)";
        }}
      >
        <SiLine size={18} /> LINE @638lkjit
      </a>
    </>
  );
};

export default SiteNavbar;
